"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorDialogActions = void 0;

var _react = _interopRequireDefault(require("react"));

var _nikeDesignSystemComponents = require("@nike/nike-design-system-components");

var _ErrorDialogActionsStyled = require("./ErrorDialogActionsStyled");

/**
 * @name ErrorDialogActions
 * @description Component which renders error dialog actions.
 * @param {Object} Props - ErrorDialogActions parameter object
 * @param {string} Props.actionTitle - Title of action button.
 * @param {function} Props.closeModal - A function to close an error dialog.
 * @returns {JSX.Element}
 * @memberof mfe-inline-cookie
 */
var ErrorDialogActions = function ErrorDialogActions(_ref) {
  var actionTitle = _ref.actionTitle,
      closeModal = _ref.closeModal;
  var isMobile = (0, _nikeDesignSystemComponents.useMatchMedia)((0, _nikeDesignSystemComponents.useBreakpoint)('lt', 's'));
  return /*#__PURE__*/_react.default.createElement(_ErrorDialogActionsStyled.ErrorDialogActionsStyled, null, /*#__PURE__*/_react.default.createElement(_nikeDesignSystemComponents.ButtonStyled, {
    appearance: "primary",
    type: "button",
    size: isMobile ? 'responsive' : 'small',
    "data-testid": "dialog-okay-button",
    ariaLabel: actionTitle,
    onClick: closeModal
  }, actionTitle));
};

exports.ErrorDialogActions = ErrorDialogActions;